/* Predicted seats / vote share time series chart */
(function () {
    var API_BASE    = 'https://pollingreport.uk/api/v1';
    var CHARTJS_CDN = 'https://cdn.jsdelivr.net/npm/chart.js@4/dist/chart.umd.min.js';

    var partyColors = {
        reform: '#26C6DA',
        lab:    '#FF1744',
        con:    '#1E88E5',
        lib:    '#F6A800',
        snp:    '#F2D232',
        green:  '#5AD313',
        plaid:  '#3F8428',
        other:  '#BDBDBD'
    };

    var partyLabels = {
        con: 'CON', lab: 'LAB', lib: 'LD', snp: 'SNP',
        green: 'GRN', reform: 'REF', plaid: 'PC', other: 'OTH'
    };

    var roots = document.querySelectorAll('[data-ukpr-results-history]');
    if (!roots.length) return;

    roots.forEach(function (root) {
        if (root.dataset.initialized) return;
        root.dataset.initialized = 'true';
        initWidget(root);
    });

    function initWidget(root) {
        var canvas    = root.querySelector('[data-rh-canvas]');
        var legend    = root.querySelector('[data-rh-legend]');
        var modelSel  = root.querySelector('[data-rh-model]');
        var loading   = root.querySelector('[data-rh-loading]');
        var toggleBtns = root.querySelectorAll('[data-rh-toggle]');

        var selected = root.dataset.rhDefault === 'vote' ? 'vote' : 'seats'; // 'seats' | 'vote'
        var cachedData = null;
        var chart = null;
        var firstRenderDone = false;

        function emitModelChanged(model) {
            try {
                document.dispatchEvent(new CustomEvent('ukpr:results-history-model-change', {
                    detail: { model: model || 'uniform', root: root }
                }));
            } catch (e) { /* silent */ }
        }

        toggleBtns.forEach(function (btn) {
            btn.classList.toggle('is-active', btn.dataset.rhToggle === selected);
        });

        toggleBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                if (btn.dataset.rhToggle === selected) return;
                selected = btn.dataset.rhToggle;
                toggleBtns.forEach(function (b) {
                    b.classList.toggle('is-active', b.dataset.rhToggle === selected);
                });
                if (cachedData) renderChart(cachedData);
            });
        });

        modelSel.addEventListener('change', function () {
            emitModelChanged(modelSel.value);
            fetchData(modelSel.value);
        });

        function fetchData(model) {
            if (loading) loading.hidden = false;
            var url = API_BASE + '/results?simplified=true&legacy=false&model=' + encodeURIComponent(model);
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.onload = function () {
                if (loading) loading.hidden = true;
                if (xhr.status !== 200) return;
                try {
                    var resp = JSON.parse(xhr.responseText);
                    cachedData = resp.data;
                    ensureChartJS(function () { renderChart(cachedData); });
                } catch (e) { /* silent */ }
            };
            xhr.onerror = function () { if (loading) loading.hidden = true; };
            xhr.send();
        }

        function ensureChartJS(cb) {
            if (window.Chart) { cb(); return; }
            var s = document.createElement('script');
            s.src = CHARTJS_CDN;
            s.onload = cb;
            document.head.appendChild(s);
        }

        function formatLabel(isoStr) {
            var d = new Date(isoStr);
            var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            return d.getDate() + ' ' + months[d.getMonth()];
        }

        function renderChart(data) {
            var labels = (data.labels || []).map(formatLabel);
            var datasets = (data.datasets || []).map(function (ds) {
                return {
                    label: ds.label,
                    data: ds[selected],
                    borderColor: partyColors[ds.label] || '#999',
                    backgroundColor: partyColors[ds.label] || '#999',
                    borderWidth: 2.5,
                    pointRadius: 0,
                    tension: 0.3,
                    fill: false
                };
            });

            if (chart) {
                chart.data.labels = labels;
                chart.data.datasets = datasets;
                chart.options.animation.duration = firstRenderDone ? 400 : 1500;
                chart.update();
                firstRenderDone = true;
            } else {
                var ctx = canvas.getContext('2d');
                chart = new Chart(ctx, {
                    type: 'line',
                    data: { labels: labels, datasets: datasets },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        animation: { duration: 1500, easing: 'easeInOutCubic' },
                        plugins: {
                            legend: { display: false },
                            tooltip: {
                                mode: 'index',
                                intersect: false,
                                callbacks: {
                                    label: function (ctx) {
                                        var suffix = selected === 'vote' ? '%' : '';
                                        return (partyLabels[ctx.dataset.label] || ctx.dataset.label.toUpperCase())
                                            + ': ' + ctx.parsed.y + suffix;
                                    }
                                }
                            }
                        },
                        scales: {
                            x: {
                                grid: { display: false },
                                ticks: {
                                    maxTicksLimit: 8,
                                    maxRotation: 0,
                                    color: 'rgba(128,128,128,0.8)',
                                    font: { size: 11 }
                                }
                            },
                            y: {
                                position: 'right',
                                grid: { color: 'rgba(128,128,128,0.15)' },
                                ticks: {
                                    color: 'rgba(128,128,128,0.8)',
                                    font: { size: 11 },
                                    callback: function (v) {
                                        return v + (selected === 'vote' ? '%' : '');
                                    }
                                }
                            }
                        },
                        interaction: { mode: 'index', intersect: false }
                    }
                });
                firstRenderDone = true;
            }

            if (firstRenderDone && !root.classList.contains('is-ready')) {
                requestAnimationFrame(function () {
                    root.classList.add('is-ready');
                    root.classList.remove('is-intro');
                });
            }

            renderLegend(data.datasets);
        }

        function renderLegend(datasets) {
            // Sort by latest value descending; 'other' always last
            var entries = (datasets || []).map(function (ds) {
                var vals = ds[selected] || [];
                return { key: ds.label, val: vals[vals.length - 1] || 0 };
            });
            entries.sort(function (a, b) {
                if (a.key === 'other') return 1;
                if (b.key === 'other') return -1;
                return b.val - a.val;
            });

            var suffix = selected === 'vote' ? '%' : '';
            legend.innerHTML = entries.map(function (e) {
                var color = partyColors[e.key] || '#999';
                var label = partyLabels[e.key] || e.key.toUpperCase();
                return '<div class="ukpr-rh-legend-row">'
                    + '<span class="ukpr-rh-legend-dot" style="background:' + color + '"></span>'
                    + '<span class="ukpr-rh-legend-label">' + label + '</span>'
                    + '<span class="ukpr-rh-legend-val">' + e.val + suffix + '</span>'
                    + '</div>';
            }).join('');
        }

        // Kick off
        emitModelChanged(modelSel.value || 'uniform');
        fetchData(modelSel.value || 'uniform');
    }

})();
